import { render, staticRenderFns } from "./BulkEmailNew.vue?vue&type=template&id=52d73532&"
import script from "./BulkEmailNew.vue?vue&type=script&lang=js&"
export * from "./BulkEmailNew.vue?vue&type=script&lang=js&"
import style0 from "./BulkEmailNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports